module.exports = __webpack_public_path__ + "static/media/logo.6508a315.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo.png
// module id = 208
// module chunks = 1